import { BigOrZero } from '../big';

export class ArrayCollection<T> extends Array {
  sumOf(prop: keyof T) {
    return this.reduce((out, item: T) => {
      if (!item || !item[prop]) {
        return out;
      }
      const propVal = BigOrZero((item[prop] as unknown as number) || 0);
      return out.plus(propVal);
    }, BigOrZero(0));
  }

  items() {
    return this;
  }

  count() {
    return this.length;
  }
}
